import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import type { ButtonGroupStoryblok, ButtonStoryblok } from "@/component-types-sb";

type ButtonGroupProps = {
  blok: ButtonGroupStoryblok;
};

const ButtonGroup = ({ blok }: ButtonGroupProps) => (
  <div
    className="flex flex-col md:flex-row gap-4 md:items-center mt-8 [&>*]:w-full [&>*>*]:w-full md:[&>*]:w-auto md:[&>*>*]:w-auto [&>*]:text-center md:[&>*]:text-left"
    {...storyblokEditable(blok)}
  >
    {blok.buttons?.map((nestedBlok: ButtonStoryblok) => (
      <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
    ))}
  </div>
);

export default ButtonGroup;
